export default __webpack_public_path__ + "static/media/Maple-MediumItalic.54841d00.ttf";